<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">ONT {{ ontIndex }}</div>
      </div>
    </div>
    <!--页面提示
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the ont info." }}
      </p>
    </div>-->
    <div>
      <span style="margin: 1px"></span>
    </div>
    <div>
      <tabs v-model="activeIndex">
        <!--ont info-->
        <pane label="OntInfo">
          <div class="row">
            <div class="col-lg-12" v-show="true">
              <block-cntr
                :btitle="'ONT Info'"
                style="height: 100%"
                :closeButton="false"
              >
                <form class="form-horizontal">
                  <div
                    class="form-group"
                    v-for="(value, key) in ontInfo"
                    :key="key"
                  >
                    <div class="col-lg-4">
                      <label>{{ value.k }}</label>
                    </div>
                    <div class="col-lg-8">
                      <label>{{ value.v }}</label>
                    </div>
                  </div>
                </form>
              </block-cntr>
            </div>
          </div>
        </pane>
        <!--ont optical info-->
        <pane label="Optical">
          <div class="row" v-show="true">
            <div class="col-lg-12">
              <block-cntr
                :btitle="'ONT Optical Info'"
                style="height: 100%"
                :closeButton="false"
              >
                <!-- 按钮 -->
                <div class="form-inline" style="height: 35px">
                  <span style="float: left">
                    <div class="btn-group open">
                      <div
                        @click="loadontOpticalInfo()"
                        class="btn"
                        style="padding: 0px"
                      >
                        <i class="fa fa-refresh page-tableaction"></i>
                      </div>
                    </div>
                  </span>
                </div>
                <form class="form-horizontal">
                  <div
                    class="form-group"
                    v-for="(value, key) in ontOpmInfo"
                    :key="key"
                  >
                    <div class="col-lg-4">
                      <label>{{ value.k }}</label>
                    </div>
                    <div class="col-lg-8">
                      <label>{{ value.v }}</label>
                    </div>
                  </div>
                </form>
              </block-cntr>
            </div>
          </div>
        </pane>
        <!--ont port status-->
        <pane label="PortStatus">
          <div class="row">
            <div class="col-lg-12">
              <block-cntr
                :btitle="'ONT Ethernet Port'"
                style="min-height: 100%"
                :closeButton="false"
              >
                <!-- 按钮 -->
                <div class="form-inline" style="height: 35px">
                  <span style="float: left">
                    <div class="btn-group open">
                      <div
                        @click="loadontPortStatus()"
                        class="btn"
                        :class="{}"
                        style="padding: 0px"
                      >
                        <i class="fa fa-refresh page-tableaction"></i>
                      </div>
                      <div
                        @click="clkEdit()"
                        class="btn"
                        :class="{ disabled: false }"
                        style="padding: 0px"
                      >
                        <i class="fa fa-edit page-tableaction"></i>
                      </div>
                    </div>
                  </span>
                </div>
                <table class="table table-hover table-noneborder-top">
                  <thead>
                    <tr>
                      <th width="40px">
                        <input
                          type="checkbox"
                          v-model="isSelectAll"
                          @change="changeSelectAll()"
                          id="idSelectAll"
                        />
                        <label for="idSelectAll"></label>
                      </th>
                      <th
                        v-for="(value, key) in ontPort.title"
                        :key="key"
                        :title="value"
                      >
                        {{ value }}
                      </th>
                    </tr>
                  </thead>
                  <tbody style="height: 100%">
                    <tr v-for="(row, index) in ontPort.data" :key="row.port">
                      <td width="40px">
                        <div v-if="!row.isNew">
                          <input
                            type="checkbox"
                            v-model="row.selected"
                            :id="'idRowSelect' + index"
                          />
                          <label :for="'idRowSelect' + index"></label>
                        </div>
                      </td>
                      <td>
                        <div>{{ row.port }}</div>
                      </td>
                      <td>
                        <div>{{ row.enable }}</div>
                      </td>
                      <td>
                        <div
                          class="fa fa-circle"
                          :style="{
                            color:
                              row.linkstatus === 'linkUp'
                                ? '#32CD32'
                                : '#FF4500',
                          }"
                        ></div>
                      </td>
                      <td>
                        <div>{{ row.mode }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!--配置弹窗-->
                <div v-if="isShowAddTable">
                  <dialog-box
                    :btitle="'Port Admin'"
                    @close="isShowAddTable = false"
                    style="height: 100%"
                    :closeButton="true"
                  >
                    <form class="form-horizontal" role="form">
                      <div class="form-group">
                        <label class="col-sm-3 control-label" for="portadmin">
                          Admin
                        </label>
                        <div class="col-sm-5">
                          <select
                            type="text"
                            class="form-control"
                            id="portadmin"
                            v-model="ontPortAdmin"
                          >
                            <option label="shutdown" value="0"></option>
                            <option label="no shutdown" value="1"></option>
                          </select>
                        </div>
                      </div>

                      <button
                        type="button"
                        class="btn btn-primary"
                        style="
                          margin-left: 25%;
                          min-width: 77px;
                          color: #fff;
                          background-color: #008b8b;
                          border-color: #008080;
                        "
                        @click="ontPortAdminSet()"
                      >
                        {{ "Apply" }}
                      </button>
                      <span style="margin-left: 10px">
                        <button
                          type="button"
                          class="btn btn-default"
                          style="min-width: 77px"
                          @click="clkCancel()"
                        >
                          {{ "Cancel" }}
                        </button>
                      </span>
                    </form>
                  </dialog-box>
                </div>
              </block-cntr>
              <!--ont catv port-->
              <ont-catv-port :ontIndex="ontIndex"></ont-catv-port>
              <!--ont pots port-->
              <ont-pots-port :ontIndex="ontIndex"></ont-pots-port>
            </div>
          </div>
        </pane>
        <!--ont statistics-->
        <pane label="Statistics">
          <ont-statistics :ontIndex="ontIndex"></ont-statistics>
        </pane>
        <!--ont mac table-->
        <pane label="Mac Table">
          <ont-mac-table :ontIndex="ontIndex"></ont-mac-table>
        </pane>
        <!--ont profile-->
        <pane label="Configuration">
          <ont-profile :ontIndex="ontIndex"></ont-profile>
        </pane>
      </tabs>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "@/components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import tabs from "@/components/Tabs.vue"
import pane from "@/components/Pane.vue"
import OntCatvPort from "@/views/OntCatvPortStatus.vue"
import OntPotsPort from "@/views/OntPotsPortStatus.vue"
import OntStatistics from "@/views/OntStatistics.vue"
import OntMacTable from "@/views/OntMacTable.vue"
import OntProfile from "@/views/OntProfileConfig.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "ontInfo",
  data() {
    return {
      ontIndex: this.$route.query.ontIndex,
      activeIndex: 0,
      isShowAddTable: false,
      isSelectAll: false,
      iBox: {},
      ontInfo: "",
      ontOpmInfo: "",
      ontPort: "",
      ontPortAdmin: "",
    }
  },
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
    tabs,
    pane,
    OntCatvPort,
    OntPotsPort,
    OntStatistics,
    OntMacTable,
    OntProfile,
  },
  created() {
    this.loadontInfo()
    this.loadontOpticalInfo()
    this.loadontPortStatus()
  },
  methods: {
    loadontInfo() {
      get("ontInfo?ontIndex=" + this.ontIndex)
        .then((res) => (this.ontInfo = res.data))
        .catch((err) => {
          this.ontInfo = en.ontInfo
        })
    },
    loadontOpticalInfo() {
      get("ontOpticalInfo?ontIndex=" + this.ontIndex)
        .then((res) => (this.ontOpmInfo = res.data))
        .catch((err) => {
          this.ontOpmInfo = en.ontOpmInfo
        })
    },
    loadontPortStatus() {
      get("ontPortStatus?ontIndex=" + this.ontIndex)
        .then((res) => (this.ontPort = res.data))
        .catch((err) => {
          this.ontPort = en.ontPort
        })
    },

    clkEdit() {
      for (let i = 0; i < this.ontPort.data.length; i++) {
        if (this.ontPort.data[i].selected) {
          if (this.ontPort.data[i].enable == "enable") {
            this.ontPortAdmin = "1"
          } else {
            this.ontPortAdmin = "0"
          }
          this.isShowAddTable = true
          return
        }
      }
    },
    changeSelectAll() {
      for (let i = 0; i < this.ontPort.data.length; i++) {
        if (this.isSelectAll) {
          this.ontPort.data[i].selected = true
        } else {
          this.ontPort.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.ontPort.data.length; i++) {
        this.ontPort.data[i].selected = false
      }
      this.isSelectAll = false
    },
    clkCancel() {
      this.isShowAddTable = false
    },
    ontPortAdminSet() {
      var ontPortCfg = {
        ontIndex: this.ontIndex,
        admin: Number(this.ontPortAdmin),
        portList:[]
      }

      for (let i = 0; i < this.ontPort.data.length; i++) {
        if (this.ontPort.data[i].selected) {
          ontPortCfg.portList.push({ port: Number(this.ontPort.data[i].port) })
        }
      }
      post("ontPortConfig", ontPortCfg)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadontPortStatus()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })

      this.isShowAddTable = false
      this.selectNull()
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>